import React, { Component } from 'react'
import Grid from "@material-ui/core/Grid";
import { Auth } from "aws-amplify";
import {Modal} from "react-bootstrap";
import styles from "../../../Assets/CSS/stylesheet_UHS";
import Loader from "../../loader";
import customStyle from "../../../Assets/CSS/stylesheet_UHS";
import Sample from "../../CommonScreens/sampleTextField";
import SampleName from '../../CommonScreens/sampleTextFieldName';
import axios from "axios";
import configurations from "../../../configurations";
import AgentTable from '../../CommonScreens/AgentTable';
import MessageToast from '../../CommonScreens/MessageToast';
import {withStyles} from "@material-ui/core/styles"
import Button from "@material-ui/core/Button";
import Fab from "@material-ui/core/Fab";
import Header from "../Headers/Header";
import Footer from "../../CommonScreens/Footer";
import {connect} from "react-redux";
import { getQueryParams, getEmployerScopedEmpidForApi, buildGetTotalOfMemberByAgentIdUrl, shouldUseEmployerMemberTotalsScope, buildEmployerPaymentPayload } from "../../authentication/utils";
import Tooltip from '@material-ui/core/Tooltip';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import moment from "moment";
import LastRefreshTimer from '../../CommonScreens/LastRefreshTimer';
import Dashboard from '../../CommonScreens/Dashboard';
import ResourceCenter from "../../CommonScreens/ResourceCenter";
import CommonDropDwn from "../../CommonScreens/CommonDropDwn_1";
import CommonDropDwnProg from "../../CommonScreens/CommonDropDwn";
import MuiPhoneNumber from "material-ui-phone-number";

/* For edit employer modal */
import { KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import Checkbox from '@material-ui/core/Checkbox';
import Switch from '@material-ui/core/Switch';
import { FormControl, InputLabel, Select, TextField, Typography, MenuItem, ListItemText, OutlinedInput } from "@material-ui/core";
import TabView from './TabView/TabView';
import Commission from './Commission';
import SignForm from './SignForm';
import ShimmerDashboard from '../../../Assets/Loaders/ShimmerEffect';
import RefreshIcon from "@mui/icons-material/Refresh";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Platform from 'react-platform-js';
// import EditEmployer from './EditEmployer'
var convert = require('xml-js');

const CustomTooltip = withStyles({
    tooltip: {
        fontSize: 14,
    },
})(Tooltip);

const CustomTextField = withStyles(
    styles.textField
)(TextField);

const CssTextField = withStyles(theme => ({
    root: {
        '& .MuiInput-root': {
            "&:hover:not($disabled):not($focused):not($error):before": {
                borderBottom: '2px solid #1a2c40'
            },

            '&.MuiInput-underline.Mui-focused:after': {
                borderBottom: '2px solid #1a2c40',
            },

        }
    },
}))(TextField);

/* end */



const GenBtn1 = withStyles(
    customStyle.genrateBtn1
)(Button);

const NextButton = withStyles(
    styles.doneBtn
)(Button);

const CustomButton = withStyles(
    customStyle.viewBtn
)(Button);
const CrudButton = withStyles(
    styles.crudBtnAgent,
)(Fab);
const NextButton1 = withStyles(
    styles.doneBtnAgent
)(Button);

const PurpleRadio = withStyles(customStyle.radioBtn)((props) => (
    <Radio color="default" {...props} />
));
class Prospect extends Component{
    constructor(props) {
        super(props);
		
		/* Edit employer  */
        let USER_DATA = {};
        try {
            const raw = sessionStorage.getItem("USER_DATA");
            if (raw) {
                USER_DATA = JSON.parse(raw) || {};
            }
        } catch (e) {
            USER_DATA = {};
        }
        const today = new Date();
        const tomorrow = new Date(today);
        if (
            USER_DATA &&
            USER_DATA.clientId != null &&
            (USER_DATA.clientId.toString() === "6548" ||
                USER_DATA.clientId.toString() === "5647" ||
                USER_DATA.clientId.toString() === "4391" ||
                USER_DATA.clientId.toString() === "4367" ||
                USER_DATA.clientId.toString() === "5540" ||
                USER_DATA.clientId.toString() === "4376" ||
                USER_DATA.clientId.toString() === "5541" ||
                USER_DATA.clientId.toString() === "4377")
        ) {
            if (new Date() < new Date("05/01/2021")) {
                tomorrow.setDate(1);
                tomorrow.setMonth(4);
            } else if (new Date().getDate() === 1 || new Date().getDate() > 1) {
                tomorrow.setDate(1);
                tomorrow.setMonth(today.getMonth() + 1);
            }
        } else {
            tomorrow.setDate(tomorrow.getDate() + 1);
        }
		/* end  */
		
        this.state = {
			USER_DATA: USER_DATA, 
            userList : [],
            headerList : ["User Id", "User Name", "Email Id", "Status"],
            modalShow : false,
            loaderShow : false,
            mailModal : false,
            bid:'',
            cid:'',
            aid:'',
            url:'',
            fname:'',
            lname:'',
            email:'',
            phone:'',
            genrate : false,
            openMailModal : false,
            countryCode : '',
            userValid : false,
            openMenu:null,
            msgModal : false,
            msgModal1:false,
            msgType: 'success',
            errMsg : "",
            empid : '',
            countData : {},
            viewEmployerModal : false,
            employerDetailsObj : [],
            emp_email_id : null,
            confirmationModal : false,
            selectedEmail : '',
			topbarData:null,
			 editEmp:false,

            loaderCommission: true,


            compName: '',
            zipCode: '',
            state: '',
            city: '',
            street: '',
            division: '',
            industry: '',
            codeTitle:'',
            code: '',
            firstName: '',
            lastName: '',
            workEmail: '',
            jobTitle: '',
            phone: '',
            divisionList: [],
            industryList: [],
            codeTitleList: [],
            codeList: [],
            countryCode: '',
            effectiveDate: new Date(tomorrow),
            dateErr: false,
            birthDtFocus: false,
            birthDt: false,
            adminPhone: '',
            adminFirstName: '',
            adminLastName: '',
            adminEmail: '',
            adminCountryCode: '',
            // empid: '',
            page: 0,
            copyEmpCheck: false,
            sendQuoteFlag:false,
            sendQuoteError:[],
            planList: [],
            planNames: [],
            tabActive: 0,
            agentProfile: null,
            agentProfileLoaded: process.env.REACT_APP_PORTAL === 'employer',
            includeDownline: true,
            lastRefreshAt: null,
            payrollCycle: 'Weekly',
            employerContribution: '',
            contributionType: 'Doller',
            accountTypes: [],
            bankName: '',
            accountName: '',
            routingNo: '',
            accountNumber: '',
            accountType: '',
            isAcknowledged: false,
            acknowledgementChecked: false,
            empDetails: null,
        }
    }

    checkEmployerAcknowledgement = async () => {
        let ipAddress = null
        await axios.get('https://geolocation-db.com/json/')
            .then(res => {
                console.log(res.data.IPv4);
                ipAddress = res.data.IPv4;
            })
        if (process.env.REACT_APP_PORTAL !== 'employer') {
            return Promise.resolve(true);
        }

        const empEmail = sessionStorage.getItem('email');
        const empid =
            getEmployerScopedEmpidForApi(this.state.empid) ||
            localStorage.getItem('loggedInEmpId');

        if (!empEmail && !empid) {
            return new Promise((resolve) => {
                this.setState(
                    { acknowledgementChecked: true, loaderShow: false },
                    () => resolve(true),
                );
            });
        }

        const employerUrl = empEmail
            ? `${process.env.REACT_APP_BASE_URL}/employer/getEmployerByEmail/${encodeURIComponent(empEmail)}`
            : `${process.env.REACT_APP_BASE_URL}/employer/getEmployerByEmpId/${encodeURIComponent(empid)}`;

        return axios
            .get(employerUrl)
            .then((response) => {
                const emp = response.data && response.data.response;
                const isAcknowledged = !!(emp && emp.acknowledgement);
                const date = new Date();
                const dateAsString = date.toString();
                const timezone = dateAsString.match(/\(([^\)]+)\)$/)[1];
                var matches = timezone.match(/\b(\w)/g);
                var abbreviations = matches.join('');

                let userData = {
                    empid: response.data.response.empid,
                    timeZone: abbreviations,
                    ipAddress,
                    browser: Platform.Browser,
                    device: Platform.DeviceType || "computer",
                    os: Platform.OS
                }

                console.log('data88', userData);
                axios.post(configurations.baseUrl + '/employer/employerLoginDetails', userData)
                    .then(res => console.log(res))
                return new Promise((resolve) => {
                    this.setState(
                        {
                            loaderShow: false,
                            empDetails: emp,
                            isAcknowledged,
                            acknowledgementChecked: true,
                            empid: (emp && emp.empid) || this.state.empid,
                        },
                        () => resolve(isAcknowledged),
                    );
                });
            })
            .catch((err) => {
                console.error('checkEmployerAcknowledgement', err);
                return new Promise((resolve) => {
                    this.setState(
                        {
                            loaderShow: false,
                            acknowledgementChecked: true,
                            isAcknowledged: false,
                        },
                        () => resolve(false),
                    );
                });
            });
    };

    setEmployerAcknowledged = (acknowledged) => {
        sessionStorage.setItem('employerAcknowledgement', acknowledged ? 'true' : 'false');
        this.setState({ isAcknowledged: acknowledged }, () => {
            if (acknowledged) {
                const empid =
                    getEmployerScopedEmpidForApi(this.state.empid) ||
                    localStorage.getItem('loggedInEmpId');
                if (empid) {
                    this.getTotalEmpInfo(empid);
                }
                this.getTopBarData();
            }
        });
    };

    handleEnrollmentTabChange = (index) => {
        this.setState({ tabActive: index });
        if (index === 0) {
            // Dashboard tab selected, refresh top bar data
            this.getTopBarData();
        }
        // Add more API calls here if needed for other tabs
    }

    loadAgentProfile = () => {
        if (process.env.REACT_APP_PORTAL === 'employer') return;
        let agentId = null;
        try {
            agentId = (JSON.parse(sessionStorage.getItem("USER_DATA")) || {}).agentId;
        } catch (e) { /* ignore */ }
        if (!agentId) {
            this.setState({ agentProfileLoaded: true });
            return;
        }
        axios
            .get(`${process.env.REACT_APP_BASE_ROOT_URL}/veraagency/api/v1/agent/${agentId}`)
            .then((response) => this.setState({ agentProfile: (response.data && response.data.data) || null, agentProfileLoaded: true }))
            .catch(() => this.setState({ agentProfileLoaded: true }));
    }

    // Independent agents get an extra Commissions tab (for their own agency).
    isIndependentAgent = () => {
        const p = this.state.agentProfile;
        return !!p && !!p.agencyId && String(p.agentType).toUpperCase() === 'INDEPENDENT AGENT';
    }

    getTopBarData = () => {
        this.setState({ loaderCommission: true });
        let ud = {};
        try {
            const raw = sessionStorage.getItem("USER_DATA");
            if (raw) {
                ud = JSON.parse(raw);
            }
        } catch (e) {
            this.setState({ loaderCommission: false });
            return;
        }
        if (!ud || ud.agentId == null) {
            this.setState({ loaderCommission: false });
            return;
        }
        const totalMembersUrl = buildGetTotalOfMemberByAgentIdUrl(
            ud.agentId,
            this.state.empid || (getQueryParams().empid || ""),
        );
        if (!totalMembersUrl) {
            this.setState({ loaderCommission: false });
            return;
        }
        axios
            .get(totalMembersUrl)
            .then((response) => {
                this.setState({
                    topbarData: response.data.response,
                    loaderCommission: false,
                    lastRefreshAt: new Date(),
                    currentTime: new Date(),
                });
            })
            .catch(() => {
                this.setState({ loaderCommission: false });
            });
    }

    /** When opening prospects with ?empid= (employer login), session may lack USER_DATA until APIs run. */
    syncEmployerUserDataFromEmpid = async (empid) => {
        try {
            const id = getEmployerScopedEmpidForApi(empid);
            if (!id) {
                return;
            }
            let existing = {};
            try {
                const raw = sessionStorage.getItem("USER_DATA");
                if (raw) {
                    existing = JSON.parse(raw) || {};
                }
            } catch (e) {
                existing = {};
            }
            if (existing.agentId != null && existing.clientId != null) {
                return;
            }
            const baseUrl = process.env.REACT_APP_BASE_URL;
            const empRes = await axios.get(
                `${baseUrl}/employer/getEmployerByEmpId/${encodeURIComponent(id)}`,
            );
            const empDetail = empRes.data && empRes.data.response;
            if (!empDetail) {
                return;
            }
            const brokerId =
                empDetail.brokerId != null ? empDetail.brokerId : empDetail.agentId;
            const clientId = empDetail.clientId;
            if (brokerId == null || clientId == null) {
                return;
            }
            const [clientRes, agentRes] = await Promise.all([
                axios.get(`${baseUrl}/employer/getClientInfo/${clientId}`),
                axios.get(`${baseUrl}/agentlogin/getAgentById/${brokerId}`),
            ]);
            const userData = clientRes.data && clientRes.data.response;
            const agentData = agentRes.data && agentRes.data.response;
            if (!userData || !agentData) {
                return;
            }
            sessionStorage.setItem(
                "USER_DATA",
                JSON.stringify({
                    agentId: agentData.brokerId,
                    clientId: userData.clientId,
                    associationId: agentData.associationId,
                    clientName: userData.clientName,
                    defaultEmpid: agentData.defaultEmpid || "",
                    role: agentData.role || "Agent",
                    employerEmpid: String(id),
                }),
            );
            sessionStorage.setItem("clientName", userData.clientName);
            if (userData.customerServiceNo) {
                sessionStorage.setItem("customerServiceNo", userData.customerServiceNo);
            }
        } catch (e) {
            console.error("syncEmployerUserDataFromEmpid", e);
        }
    }

    // The page scrolls inside a container below the fixed header, so the scrollbar
    // never runs behind the header. The header height is measured at runtime.
    measureHeader = () => {
        const header = document.querySelector('header.MuiAppBar-root');
        const headerHeight = header ? header.offsetHeight : 0;
        if (headerHeight !== this.state.headerHeight) this.setState({ headerHeight });
    }

    componentDidMount() {
        this.setState({
            loaderShow: true,
        });
        this.measureHeader();
        this.measureHeaderTimer = setTimeout(this.measureHeader, 500);
        window.addEventListener('resize', this.measureHeader);
        this.loadAgentProfile();

        Auth.currentSession().then((session) => {}).catch((error) => {
            localStorage.clear();
            sessionStorage.clear();
            window.location.href = "/login";
        });

        const queryParams = getQueryParams();
        const resolvedProspectEmpid = getEmployerScopedEmpidForApi(
            queryParams && queryParams.empid,
        );

        const runAfterUserData = async () => {
            if (process.env.REACT_APP_PORTAL === 'employer') {
                const acknowledged = await this.checkEmployerAcknowledgement();
                if (!acknowledged) {
                    return;
                }
            }

            this.getTopBarData();

            /* Edit employer */
            let obj = {
                searchKey: "division",
                searchValue: "",
            };
            axios
                .post(process.env.REACT_APP_BASE_URL + "employer/getSIC", obj)
                .then((response) => {
                    let divisionList = [];
                    for (let i = 0; i < response.data.response.length; i++) {
                        divisionList.push({
                            key: response.data.response[i].division,
                            value: response.data.response[i].division,
                        });
                    }

                    this.setState({
                        divisionList: divisionList,
                    });
                });

            fetch(configurations.baseUrl.replace("agent/", "") + "setuppayment/getAccountType")
                .then((response) => response.json())
                .then((response) => {
                    const accountTypes = (response.response || []).map((item) => {
                        if (typeof item === 'string') {
                            return { key: item, value: item };
                        }
                        const label = item.key || item.value || item.name || item.accountType || '';
                        const value = item.value || item.key || item.name || item.accountType || '';
                        return { key: label, value: value };
                    });
                    this.setState({
                        accountTypes: accountTypes,
                    });
                })
                .catch((error) => {
                    console.log(error);
                });

            /* end */

            window.addEventListener("REFRESH", this.refreshCount);

            if (resolvedProspectEmpid) {
                let syncedUser = {};
                try {
                    const raw = sessionStorage.getItem("USER_DATA");
                    if (raw) {
                        syncedUser = JSON.parse(raw) || {};
                    }
                } catch (e) {
                    syncedUser = {};
                }
                this.setState(
                    {
                        empid: resolvedProspectEmpid,
                        tabActive:
                            queryParams.tab === "prospects"
                                ? 1
                                : queryParams.tab === "members"
                                  ? 2
                                  : 0,
                        ...(Object.keys(syncedUser).length ? { USER_DATA: syncedUser } : {}),
                    },
                    () => this.handleEmpDetails("didM"),
                );
                this.getTotalEmpInfo(resolvedProspectEmpid);
                sessionStorage.setItem("EMPLOYER_FLOW", "YES");
            } else {
                let userdata = {};
                try {
                    const raw = sessionStorage.getItem("USER_DATA");
                    if (raw) {
                        userdata = JSON.parse(raw) || {};
                    }
                } catch (e) {
                    userdata = {};
                }
                this.setState({
                    USER_DATA: userdata,
                    loaderShow: false,
                    empid: userdata.defaultEmpid,
                });
                sessionStorage.setItem("EMPLOYER_FLOW", "NO");
            }

            let clientId;
            try {
                const raw = sessionStorage.getItem("USER_DATA");
                if (raw) {
                    const parsed = JSON.parse(raw);
                    if (parsed && parsed.clientId != null) {
                        clientId = parsed.clientId;
                    }
                }
            } catch (e) {
                clientId = undefined;
            }
            if (clientId != null) {
                let data = { clientId };
                axios
                    .post(
                        configurations.baseUrl.replace("agent", "enrollment") + "getClient",
                        data,
                    )
                    .then((response) => {
                        if (response.data.response) {
                            let newPrgList = response.data.response.programList.split(",");
                            this.setState({
                                programsList: newPrgList,
                                program: newPrgList[0],
                                programName: response.data.response.programName,
                            });
                            this.getPlanList(newPrgList[0]);
                        }
                    });
            }
        };

        if (resolvedProspectEmpid) {
            this.syncEmployerUserDataFromEmpid(resolvedProspectEmpid).finally(() =>
                runAfterUserData(),
            );
        } else {
            runAfterUserData();
        }
    }

    componentWillUnmount() {
        window.removeEventListener('REFRESH', this.refreshCount);
        window.removeEventListener('resize', this.measureHeader);
        clearTimeout(this.measureHeaderTimer);
    }



    getPlanList = (type) => {
        let clientId;
        try {
            const raw = sessionStorage.getItem("USER_DATA");
            if (!raw) {
                return;
            }
            const parsed = JSON.parse(raw);
            clientId = parsed && parsed.clientId;
        } catch (e) {
            return;
        }
        if (clientId == null) {
            return;
        }
        axios
            .get(
                `${configurations.baseUrl.replace("/agent", "")}plan/planList/${clientId}/${type}`,
            )
            .then((response) => {
                if (response.data.plans) {
                    this.setState({
                        planNames: [],
                        planList: response.data.plans,
                    });
                }
            });
    }

    refreshCount = (e) =>{
        this.getTotalEmpInfo(e.detail)
        this.getTopBarData()
    }
	
	
	//update employer details namita

    addEmployer = () => {
        this.setState({
            loaderShow: true
        })
        // let URL = process.env.REACT_APP_BASE_URL + '/employer/addEmployer';
        let newPhone = this.state.phone.replace(/[^a-zA-Z0-9]/g, '');
        let newAdminPhone = this.state.adminPhone.replace(/[^a-zA-Z0-9]/g, '');

        let obj = {
            "clientId": this.state.USER_DATA.clientId ? this.state.USER_DATA.clientId.toString() : '',
            "companyName": this.state.compName.trim(),
            "firstName": this.state.firstName.trim(),
            "lastName": this.state.lastName.trim(),
            "jobTitle": this.state.jobTitle.trim(),
            "phone": this.state.countryCode + newPhone.substr(1),
            "zip": this.state.zipCode,
            "state": this.state.state,
            "city": this.state.city,
            "street": this.state.street,
            "effective_date": moment(this.state.effectiveDate).format('YYYY-MM-DD'),
            "brokerId": this.state.USER_DATA.agentId,
            "division": this.state.division,
            "industry": this.state.industry,
            "codeTitle": this.state.codeTitle,
            "code": this.state.code,
            adminFirstName: this.state.adminFirstName.trim(),
            adminLastName: this.state.adminLastName.trim(),
            adminPhone: this.state.adminCountryCode + newAdminPhone.substr(1),
            adminEmail: this.state.adminEmail,
            email: this.state.workEmail.toLowerCase(),
            payrollCycle: this.state.payrollCycle,
            contributionType: this.state.contributionType,
            employerContribution: this.state.employerContribution !== '' && this.state.employerContribution != null
                ? Number(this.state.employerContribution)
                : 0,
            employerPayment: buildEmployerPaymentPayload({
                bankName: this.state.bankName,
                accountName: this.state.accountName,
                accountNumber: this.state.accountNumber,
                accountType: this.state.accountType,
                routingNo: this.state.routingNo,
            }),
        }

        // if (this.state.employerEdit) {
            URL = process.env.REACT_APP_BASE_URL + '/employer/updateEmployer';
            obj.empid = this.state.empid
        // }

        axios.post(URL, obj)
            .then(response => {
                let errMsg = '';
                if (response.data.code === 200) {                    
                    errMsg = 'Employer Updated Successfully !'
                } else {
                    errMsg = response.data.message
                }
                let today = new Date();
                let tomorrow = new Date(today);
                if (this.state.USER_DATA.clientId.toString() === '6548' || this.state.USER_DATA.clientId.toString() === '5647' || this.state.USER_DATA.clientId.toString() === '4391' || this.state.USER_DATA.clientId.toString() === '4367' || 
                this.state.USER_DATA.clientId.toString() === '5540' || 
                this.state.USER_DATA.clientId.toString() === '4376' || 
                this.state.USER_DATA.clientId.toString() === '5541'|| 
                this.state.USER_DATA.clientId.toString() === '4377') {
                    if (new Date() < new Date("05/01/2021")) {
                        tomorrow.setDate(1);
                        tomorrow.setMonth(4);
                    } else if (new Date().getDate() === 1 || new Date().getDate() > 1) {
                        tomorrow.setDate(1);
                        tomorrow.setMonth(today.getMonth() + 1);
                    }
                } else {
                    tomorrow.setDate(tomorrow.getDate() + 1);
                }
                this.state.countData.companyName=this.state.compName
                this.setState({
                    msgModal: true,
                    msgType: response.data.code === 200 ? 'success' : 'error',
                    loaderShow : false,
                    // addEmployerModal: false,
                    viewEmployerModal:false,
                    errMsg: errMsg,
                    compName: '',
                    zipCode: '',
                    state: '',
                    city: '',
                    street: '',
                    division: '',
                    industry: '',
                    codeTitle: '',
                    code: '',
                    firstName: '',
                    lastName: '',
                    workEmail: '',
                    jobTitle: '',
                    phone: '',
                    industryList: [],
                    codeTitleList: [],
                    codeList: [],
                    countryCode: '',
                    employerEdit: false,
                    adminPhone: '',
                    adminFirstName: '',
                    adminLastName: '',
                    adminEmail: '',
                    adminCountryCode: '',
                    effectiveDate: new Date(tomorrow),
                    // empid: '',
                    copyEmpCheck: false,
                    payrollCycle: 'Weekly',
                    employerContribution: '',
                    contributionType: 'Doller',
                    bankName: '',
                    accountName: '',
                    routingNo: '',
                    accountNumber: '',
                    accountType: '',
                });
                // this.getEmployerData();
            })

    }
	
	
	
	

    getTotalEmpInfo = (empid) => {
        const id = getEmployerScopedEmpidForApi(empid);
        if (!id) {
            return;
        }
        axios.get(
            configurations.baseUrl +
                "/enrollment/getCountsFormEmployer/" +
                encodeURIComponent(id),
        )
            .then(response =>{
                console.log(response);
                if (response.data.code === 200) {
                    let fromSession = {};
                    try {
                        const raw = sessionStorage.getItem("USER_DATA");
                        if (raw) {
                            fromSession = JSON.parse(raw) || {};
                        }
                    } catch (e) {
                        fromSession = {};
                    }
                    this.setState({
                        countData: response.data.response,
                        USER_DATA: fromSession,
                        loaderShow: false,
                    });
                }
            })
    }

    generateUrl(val){
        this.setState({loading:true})
        var obj={
            "clientId":this.state.cid,
            "associationId":this.state.aid,
            "brokerId":this.state.bid,
            'empid' : this.state.empid
        }
        axios.post(configurations.baseUrl + '/encrypt/encryptData', obj)
            .then(res=>{
                if(res && res.response){
                    this.setState({url:this.state.baseUrl+'#state='+res.response,loading:false})
                }
            });
    }

    setValue(value,isValid,parentDetails){
        if(value !== undefined && value !== null && isValid){
            if(parentDetails.name === 'brokerid'){
                this.setState({bid:value},()=>{
                    this.checkVal('ENCODING')
                })
            }else if(parentDetails.name === 'associationid'){
                this.setState({aid:value},()=>{
                    this.checkVal('ENCODING')
                })
            }else if(parentDetails.name === 'clientid'){
                this.setState({cid:value},()=>{
                    this.checkVal('ENCODING')
                })
            }else{
                this.setState({baseUrl:value},()=>{
                    this.checkVal('ENCODING')
                })
            }
        }
    }

    setUserValue = (value,isValid,parentDetails) =>{
        if(parentDetails.name === 'firstname'){
            if(isValid){
                this.state.fname = value;
            } else {
                this.state.fname = '';
            }
        }else if(parentDetails.name === 'lastname'){
            if(isValid){
                this.state.lname = value;
            } else {
                this.state.lname = '';
            }
        }else if(parentDetails.name === 'email'){
            if(isValid){
                this.state.email = value;
            } else {
                this.state.email = "";
            }
        }else if(parentDetails.name === 'phone'){
            if(isValid ){
                this.state.phone = value;
            } else {
                this.state.phone = "";
            }
        }
        this.checkVal('USER');
    }

    checkVal(flag){
        if(flag === 'ENCODING'){
            if(this.state.cid !== '' && this.state.bid !== '' && this.state.aid !== '' && this.state.baseUrl !== ''){
                this.setState({genrate:false})
            }else{
                this.setState({genrate:true})
            }
        } else if(flag === 'USER'){
            if(this.state.fname !== '' && this.state.lname !== '' && this.state.email !== '' && this.state.phone !== ''){
                this.setState({userValid :false})
            }else{
                this.setState({userValid : true})
            }
        }

    }

    openMailModal = () => {
        this.setState({
            mailModal : true,
            genrate : false
        })
    }

    logoutPage=()=>{
        this.props.history.replace('/login');
    }

    handleMenu = (event) => {

        this.setState({
            openMenu: event.currentTarget
        })
    };
    menuClose = (event) => {

        this.setState({
            openMenu: !event.currentTarget
        })
    };

    sendMail = () => {
    }

    formatPhoneNumber = (phoneNumberString) => {
        var cleaned = ('' + phoneNumberString).replace(/\D/g, '');
        var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
        if (match) {
          var intlCode = (match[1] ? '+1 ' : '');
          return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');
        }
        return null;
      }

    handleEmpDetails = (flag) => {
        const id = getEmployerScopedEmpidForApi(this.state.empid);
        if (!id) {
            this.setState({ loaderShow: false, editEmp: true });
            return;
        }
        this.setState({
            loaderShow: true,
            editEmp: true,
        });
        axios.get(
            process.env.REACT_APP_BASE_URL +
                "/employer/getEmployerByEmpId/" +
                encodeURIComponent(id),
        )
            .then(response =>{
                console.log(response);
                if(response.data.response){
                    let phone = '';
                    let adminPhone = ''
                    console.log('mobile- - ', response.data.response);
                    if (response.data.response.phone.length === 13 || response.data.response.adminPhone.length === 13) {
                        phone = this.formatPhoneNumber(response.data.response.phone.substr(2));
                        adminPhone = this.formatPhoneNumber(response.data.response.adminPhone.substr(2));
                    } else {
                        phone = this.formatPhoneNumber(response.data.response.phone);
                        adminPhone = this.formatPhoneNumber(response.data.response.adminPhone);
                    }
                    this.setState({
                        compName:response.data.response.companyName,
                        firstName:response.data.response.firstName,
                        lastName:response.data.response.lastName,
                        email:response.data.response.email,
                        phone:phone,
                        zipCode:response.data.response.zip,
                        state:response.data.response.state,
                        city:response.data.response.city,
                        jobTitle:response.data.response.jobTitle,
                        workEmail:response.data.response.email,
                        street:response.data.response.street,
                        division:response.data.response.division,
                        industry:response.data.response.industry,
                        codeTitle:response.data.response.codeTitle,
                        code:response.data.response.code,
                        effectiveDate:response.data.response.effective_date ? moment(response.data.response.effective_date).format('MMMM DD, YYYY') : null,
                        adminFirstName:response.data.response.adminFirstName,
                        adminLastName:response.data.response.adminLastName,
                        adminEmail:response.data.response.adminEmail,
                        adminPhone:adminPhone,
                        payrollCycle: response.data.response.payrollCycle || 'Weekly',
                        contributionType: response.data.response.contributionType || 'Doller',
                        employerContribution: response.data.response.employerContribution != null && response.data.response.employerContribution !== ''
                            ? String(response.data.response.employerContribution)
                            : '',
                        bankName: (response.data.response.employerPayment && response.data.response.employerPayment.bankName) || '',
                        accountName: (response.data.response.employerPayment && response.data.response.employerPayment.accountName) || '',
                        routingNo: (response.data.response.employerPayment && response.data.response.employerPayment.routingNo) || '',
                        accountNumber: (response.data.response.employerPayment && response.data.response.employerPayment.accountNumber) || '',
                        accountType: (response.data.response.employerPayment && response.data.response.employerPayment.accountType) || '',
                    })
                    let arr = [];
                    // if(response.data.response.email == response.data.response.adminEmail){
                    //     arr.push({key : response.data.response.email, value : response.data.response.email});
                    // }else{
                    //     arr.push({key : response.data.response.email, value : response.data.response.email});
                    //     arr.push({key : response.data.response.adminEmail, value : response.data.response.adminEmail});
                    // }
                    if(response.data.response.email == response.data.response.adminEmail){
                        arr.push({key :sessionStorage.getItem('switchedEmail')+" "+"(Agent)", value : sessionStorage.getItem("switchedEmail")});
                        arr.push({key : response.data.response.email ? response.data.response.email+" "+"(Employer/Administrator)":'', value : response.data.response.email ? response.data.response.email :''});

                    }else{
                        arr.push({key :sessionStorage.getItem('switchedEmail')+" "+"(Agent)", value : sessionStorage.getItem("switchedEmail")});
                        arr.push({key : response.data.response.email +' '+"(Employer)", value : response.data.response.email});
                        arr.push({key :response.data.response.adminEmail? response.data.response.adminEmail+" "+"(Administrator)":'', value : response.data.response.adminEmail ? response.data.response.adminEmail : ''});

                    }
                                             
                    this.setState({
                        // employerDetailsObj : obj,
                        viewEmployerModal : flag !== 'didM' ?  true : false,
                        loaderShow : false,
                        emp_email_id : arr
                    })
                }
            })
    }

    handleQuoteMail = () => {
        this.setState({
            selectedEmail : '',
            confirmationModal : true
        })
    }

    setEmailId = (value, isValid, parentDetails) =>{
        const fieldName = parentDetails.name;
        const nextValue = isValid ? value : '';

        this.setState({ [fieldName]: nextValue }, () => {
            if (isValid && fieldName === 'program') {
                this.getPlanList(value);
            }
        });
    }

    handlePlanNamesChange = (event) => {
        this.setState({ planNames: event.target.value });
    }

    sendEmpQuoteMail = () =>{
        this.setState({loaderShow : true, confirmationModal : false});
        const data = {
            planNames: this.state.planNames
        }
        axios.post(process.env.REACT_APP_enrollment_base_url + '/plan/sendEmployerQuoteMail/' + this.state.USER_DATA.agentId + '/' + this.state.empid + '/' + this.state.selectedEmail + '/' + this.state.program, data)
            .then(response =>{
                console.log(response);
                let errMsg = '';
                if(response.data.code === 200){
                    errMsg = 'Quote email sent successfully!'
                } else if(response.data.code === 202){
                    errMsg = 'Age or state not available for employee.'
                } else if(response.data.code === 204){
                    errMsg = 'Email could not be send due to the following errors.'
                    this.setState({
                        sendQuoteFlag:true,
                        sendQuoteError:response.data.response
                    })
                }else {
                    errMsg = 'Internal Server Error'
                }
                
                this.setState({
                    msgModal : true,
                    msgType: response.data.code === 200 ? 'success' : 'error',
                    loaderShow : false,
                    errMsg : errMsg,
                    selectedEmail : '',
                    planNames: [],
                });
            })
    }
	
	
	// update employer details modal text value change
    setEmpValue = (value, isValid, parentDetails) => {

        if (isValid) {
            this.state[parentDetails.name] = value;
            if (parentDetails.name === 'zipCode') {
                this.handleZipCode(value, parentDetails);
            }
        } else {
            this.state[parentDetails.name] = "";
        }
        this.setState({
            refresh: true
        }, () => { this.checkEnable() });
    }

    checkEnable = () => {
        // && division !== '' && industry !== '' && codeTitle !== '' && code !== ''&& jobTitle !== '' && adminPhone !== '' && phone !== ''&& street !== '' 
        const { compName, zipCode, state, city, street, division, industry, codeTitle, code, firstName, lastName, workEmail, jobTitle, phone, adminPhone, adminFirstName, adminLastName, adminEmail } = this.state;
        if (compName !== '' && zipCode !== '' && state !== '' && city !== ''  && firstName !== '' && lastName !== '' && workEmail !== ''  && adminFirstName !== '' && adminLastName !== '' && adminEmail !== '') {
            this.setState({
                disableSubmit: false
            })
        } else {
            this.setState({
                disableSubmit: true
            })
        }
    }

    setEmpDropDownValue = (value, isValid, parentDetails) => {
        this.setState({
            loaderShow: true
        })
        if (isValid) {
            this.state[parentDetails.name] = value;
        } else {
            this.state[parentDetails.name] = "";
        }

        if (parentDetails.name === 'division') {
            this.setState({
                industryList: [],
                codeTitleList: [],
                code: ''
            })
            let obj = {
                "searchKey": "industry",
                "searchValue": value
            }

            this.getSICDetails(obj);
        } else if (parentDetails.name === 'industry') {
            this.setState({
                codeTitleList: [],
                code: ''
            })
            let obj = {
                searchKey: 'codeTitle',
                searchValue: value
            }
            this.getSICDetails(obj);
        } else if (parentDetails.name === 'codeTitle') {
            let findIndex = this.state.codeTitleList.find(obj => obj.key === value);
            if (findIndex) {
                //this.state.code = findIndex.sicCode;
                this.setState({
                    code: findIndex.sicCode,
                    loaderShow: false
                });
            }
        }
        this.setState({
            refresh: true,
        }, () => { this.checkEnable() });
    }

    getSICDetails = (obj) => {
        axios.post(process.env.REACT_APP_BASE_URL + '/employer/getSIC', obj)
            .then(response => {
                let arr = [];
                let data = response.data.response;
                if (obj.searchKey === 'industry') {
                    for (let i = 0; i < data.length; i++) {
                        arr.push({ key: data[i].industry, value: data[i].industry })
                    }
                    this.setState({
                        industryList: arr,
                        loaderShow: false
                    }, () => { this.checkEnable() })
                } else if (obj.searchKey === 'codeTitle') {
                    for (let i = 0; i < data.length; i++) {
                        arr.push({ key: data[i].codeTitle, value: data[i].codeTitle, sicCode: data[i].sicCode })
                    }
                    this.setState({
                        codeTitleList: arr,
                        loaderShow: false
                    }, () => { this.checkEnable() })
                }
            });
    }
    handleDateChange = (date, didMount) => {
        this.setState({
            effectiveDate: date
        }
            , () => {
                let panel = document.getElementById("date-picker-dialog");
                panel.addEventListener("onmouseleave", function () {
                    document.getElementById("date-picker-dialog-label").style.paddingTop = "10px";
                });
            }
        );
    }


    copyEmployerDetails = () => {
        console.log("==Clicked===");
        console.log(this.state.copyEmpCheck);
        if (this.state.copyEmpCheck == false) {
            this.setState({ 
                copyEmpCheck: true,
                adminFirstName: this.state.firstName,
                adminLastName: this.state.lastName,
                adminEmail: this.state.workEmail,
                adminPhone: this.state.phone,
            }, () => this.checkEnable())
            
        } else {
            this.setState({ 
                copyEmpCheck: false,
                adminFirstName: '',
                adminLastName: '',
                adminEmail: '',
                adminPhone: '',
            }, () => this.checkEnable())

        }

    }

    closeEmployerModal = () => {
        let today = new Date();
        let tomorrow = new Date(today);
        if (this.state.USER_DATA.clientId.toString() === '6548' || this.state.USER_DATA.clientId.toString() === '4367' || this.state.USER_DATA.clientId.toString() === '5647' || this.state.USER_DATA.clientId.toString() === '4391' 
        || this.state.USER_DATA.clientId.toString() === '5540' || this.state.USER_DATA.clientId.toString() === '4376'
        || this.state.USER_DATA.clientId.toString() === '5541'|| 
        this.state.USER_DATA.clientId.toString() === '4377'
               
        ) {
            if (new Date() < new Date("05/01/2021")) {
                tomorrow.setDate(1);
                tomorrow.setMonth(4);
            } else if (new Date().getDate() === 1 || new Date().getDate() > 1) {
                tomorrow.setDate(1);
                tomorrow.setMonth(today.getMonth() + 1);
            }
        } else {
            tomorrow.setDate(tomorrow.getDate() + 1);
        }
        this.setState({
            viewEmployerModal: false,
            errMsg: '',
            // compName: '',
            // zipCode: '',
            // state: '',
            // city: '',
            // street: '',
            // division: '',
            // industry: '',
            // codeTitle: '',
            // code: '',
            // firstName: '',
            // lastName: '',
            // workEmail: '',
            // jobTitle: '',
            // phone: '',
            // industryList: [],
            // codeTitleList: [],
            // codeList: [],
            // countryCode: '',
            // adminPhone: '',
            // adminFirstName: '',
            // adminLastName: '',
            // adminEmail: '',
            // adminCountryCode: '',
            // effectiveDate: new Date(tomorrow),
            // employerEdit: false,
            // empid: '',
            // copyEmpCheck: false
        })
    }

 // update employer details modal text value change end namita
    
 disableWeekends(date, clientId) {
    return (clientId.toString() === '6548' || clientId.toString() === '5647' || clientId.toString() === '4391' || clientId.toString() === '4367' || 
    clientId.toString() === '5540' || clientId.toString() === '4376'|| clientId.toString() === '5541'|| 
    clientId.toString() === '4377') ? (date.getDate() === 1 ? false : true) : false;
}
	
handleOK=()=>{
      this.setState({msgModal:false,sendQuoteFlag:false, loaderShow : false},()=>this.handleEmpDetails('didM'))
}	
	
	

    render() {
		 let myDate = moment(this.state.effectiveDate).format('MM') + '/' + moment(this.state.effectiveDate).format('DD') + '/' + moment(this.state.effectiveDate).format('YYYY');
        const isEmployerFlow = shouldUseEmployerMemberTotalsScope(
            this.state.empid || getQueryParams().empid || "",
        );
        const householdData = isEmployerFlow
            ? (this.state.topbarData && this.state.topbarData.emplopyer ? this.state.topbarData.emplopyer : {})
            : (this.state.topbarData && this.state.topbarData.household ? this.state.topbarData.household : {});
        const formatMoney = (value) => (value || value === 0 ? `$${value}` : '-');
        // Use LastRefreshTimer for efficient timer updates
        const sectionHeaderStyle = { color: '#4a4a4a', fontSize: 13, fontWeight: 700, letterSpacing: 0.5, marginRight: 14, whiteSpace: 'nowrap', flexShrink: 0 };
        const sectionLineStyle = { borderTop: '4px solid #e7e7f2', flex: 1 };
        const statLabelStyle = { color: '#6d6d79', fontSize: 14, lineHeight: '1.05', fontWeight: 500, minHeight: 50, letterSpacing: 0.3 };
        const statValueStyle = { color: '#181818', fontSize: 44, lineHeight: '1', fontWeight: 300, letterSpacing: 0.2 };
        const today = new Date();
        const tomorrow = new Date(today);
        tomorrow.setDate(tomorrow.getDate() + 1);
        let futureTomarow = new Date(today);
        //const futureDate = this.state.USER_DATA.clientId.toString() === '6548' ? futureTomarow.setDate(futureTomarow.getDate() + 45) : futureTomarow.setDate(futureTomarow.getDate() + 90);
        let futureDate;
        if (this.state.USER_DATA.clientId === '6548' || this.state.USER_DATA.clientId === '4367'
        || this.state.USER_DATA.clientId === 6548 || this.state.USER_DATA.clientId === 4367
        || this.state.USER_DATA.clientId === 5647 || this.state.USER_DATA.clientId === "5647"
        || this.state.USER_DATA.clientId === 4391 || this.state.USER_DATA.clientId === "4391"
        || this.state.USER_DATA.clientId === 5540 || this.state.USER_DATA.clientId === 4376
        || this.state.USER_DATA.clientId === '5540' || this.state.USER_DATA.clientId === '4376'
        || this.state.USER_DATA.clientId === '5541' || this.state.USER_DATA.clientId === '4377'
        || this.state.USER_DATA.clientId === 5541 || this.state.USER_DATA.clientId === 4377
        ) {
            if (new Date() < new Date("05/01/2021")) {
                futureTomarow.setDate(1);
                futureTomarow.setMonth(4);
                tomorrow.setDate(1);
                tomorrow.setMonth(4);
            } else if (new Date().getDate() === 1 || new Date().getDate() > 1) {
                futureTomarow.setDate(1);
                futureTomarow.setMonth(today.getMonth() + 1);
            }
            futureDate = futureTomarow.setDate(futureTomarow.getDate() + 45)
        } else {
            futureDate = futureTomarow.setDate(futureTomarow.getDate() + 90);
        }
		        
        const isSignFormPage =
            process.env.REACT_APP_PORTAL === 'employer' &&
            this.state.acknowledgementChecked &&
            !this.state.isAcknowledged;

        const headerHeight = this.state.headerHeight || 0;

        return (
            <div style={{ position: 'fixed', top: headerHeight, left: 0, right: 0, bottom: 0, overflowY: 'auto', overflowX: 'hidden' }}>
                {
                    this.state.loaderShow ? <><Loader/></> : ''
                }
                <Header  hideResource={isSignFormPage} agentId={this.state.USER_DATA.agentId} clientId={this.state.USER_DATA.clientId} associationId={this.state.USER_DATA.associationId} clientName={this.state.USER_DATA.clientName} bottomMargin={'0px'}></Header>
           

        
                <div style={{flexGrow:1,paddingLeft:'37px', paddingTop:'25px', paddingRight:'37px'}}>
                    <Grid container spacing={2} justify='center'>
                 

                        <Grid xs={12} sm={12} item={true} style={{}}>
                            {process.env.REACT_APP_PORTAL === 'employer' &&
                            !this.state.acknowledgementChecked ? (
                                <ShimmerDashboard />
                            ) : !this.state.agentProfileLoaded ? (
                                <ShimmerDashboard />
                            ) : process.env.REACT_APP_PORTAL === 'employer' &&
                              this.state.acknowledgementChecked &&
                              !this.state.isAcknowledged ? (
                                <SignForm
                                    empDetails={this.state.empDetails}
                                    setIsAcknowledged={this.setEmployerAcknowledged}
                                    setLoaderShow={(show) =>
                                        this.setState({ loaderShow: show })
                                    }
                                />
                            ) : (
                                        <TabView
                                            backgroundColor={"#1A2C40"}
                                            active={this.state.tabActive || 0}
                                            onTabChange={this.handleEnrollmentTabChange}
                                            data={[
                                                {
                                                    label: "Dashboard",
                                                    color: "#FFFFFF",
                                                    selectedColor: "#1A2C40",
                                                    selectedbgColor: "#e6e9f2",
                                                    bgcolor: "#1A2C40",
                                                    disable: false,
                                                    component: (
                                                        <Dashboard
                                                            householdData={householdData}
                                                            lastRefreshAt={this.state.lastRefreshAt}
                                                            loaderCommission={this.state.loaderCommission}
                                                            onRefresh={() => this.getTopBarData()}
                                                        />
                                                    ),
                                                },
                                                {
                                                    label: "Active Quotes",
                                                    color: "#FFFFFF",
                                                    selectedColor: "#1A2C40",
                                                    selectedbgColor: "#e6e9f2",
                                                    bgcolor: "#1A2C40",
                                                    component:  (
                                                    <div style={this.state.empid !== '' ? customStyle.agentTableHi_92 : customStyle.agentTableHi_100}>
                                                            {
                                                                    (this.state.USER_DATA && this.state.USER_DATA.clientId) &&
                                                                    <AgentTable handleQuoteMail={() => this.handleQuoteMail()} agentId={this.state.USER_DATA.agentId} clientId={this.state.USER_DATA.clientId} associationId={this.state.USER_DATA.associationId} clientName={this.state.USER_DATA.clientName} defaultEmpid={this.state.USER_DATA.defaultEmpid} employerName={this.state.countData.companyName} enrollmentFilter="prospects" isActive={this.state.tabActive === 1} noShimmer={this.state.confirmationModal}></AgentTable>
                                                            }
                                                    </div>
                                                    ),
                                                },
                                                // {
                                                //     label: "Members",
                                                //     color: "#FFFFFF",
                                                //     selectedColor: "#1A2C40",
                                                //     selectedbgColor: "#e6e9f2",
                                                //     bgcolor: "#1A2C40",
                                                //     component:  (
                                                //     <div style={this.state.empid !== '' ? customStyle.agentTableHi_92 : customStyle.agentTableHi_100}>
                                                //             {
                                                //                     (this.state.USER_DATA && this.state.USER_DATA.clientId) &&
                                                //                         <AgentTable
                                                //                             agentId={this.state.USER_DATA.agentId}
                                                //                             clientId={this.state.USER_DATA.clientId}
                                                //                             associationId={this.state.USER_DATA.associationId}
                                                //                             clientName={this.state.USER_DATA.clientName}
                                                //                             defaultEmpid={this.state.USER_DATA.defaultEmpid}
                                                //                             selectedEmployerId={this.state.empid}
                                                //                             employerName={this.state.countData.companyName}
                                                //                             enrollmentFilter="members"
                                                //                             isActive={this.state.tabActive === 2}
                                                //                             onProspectAdded={() => this.setState({ tabActive: 1 })}
                                                //                             handleQuoteMail={() => this.handleQuoteMail()}
                                                //                         />
                                                //             }
                                                //     </div>
                                                //     ),
                                                // },
                                                // {
                                                //         label: "COMMISSIONS",
                                                //         color: "#FFFFFF",
                                                //         selectedColor: "#212121",
                                                //         selectedbgColor: "#e6e9f2",
                                                //         bgcolor: "#1A2C40",
                                                //         disable:true,
                                                //         component: <div><Commission agentID={this.state.USER_DATA.agentId} /></div>,
                                                //     },
                                                ...(this.isIndependentAgent() ? [{
                                                    label: "Commissions",
                                                    color: "#FFFFFF",
                                                    selectedColor: "#1A2C40",
                                                    selectedbgColor: "#e6e9f2",
                                                    bgcolor: "#1A2C40",
                                                    component: <Commission agencyId={this.state.agentProfile.agencyId} />,
                                                }] : []),
                                                {
                                                        label: "Resources",
                                                        color: "#FFFFFF",
                                                        selectedColor: "#1A2C40",
                                                        selectedbgColor: "#e6e9f2",
                                                        bgcolor: "#1A2C40",
                                                        component: <ResourceCenter />,
                                                    },
                                        ] }
                                            />
                            )}
                        </Grid>
                    </Grid>


                    <Modal size="lg" show={this.state.mailModal} onHide={(event) => this.setState({mailModal:false,loaderShow : false})} centered backdrop='static'>
                        <Modal.Header style={styles.modal_header} closeButton>
                            <Modal.Title>Configure encoded URL</Modal.Title>
                        </Modal.Header>
                        <Modal.Body style={{ padding: '15px' }}>
                            {
                                this.state.loaderShow ? <Loader></Loader> : ''
                            }

                            <div style={customStyle.HomeContainer}>
                                <div style={customStyle.HomeMAinChild}>
                                    <div style={customStyle.HomeTextContiner}>
                                        <div style={{width:'224px', margin:'10px'}}>
                                            <Sample setChild={this.setValue.bind(this)} reqFlag={true} name={'brokerid'} label={'Broker Id'} value={this.state.bid} disable={false} style={customStyle.textFieldWrp} length={5}  fieldType={'treatment'} errMsg={'Enter Broker Id'} helperMsg={'Broker Id Required'}  parentDetails={{name:'brokerid'}}></Sample>
                                        </div>
                                        <div style={{width:'224px', margin:'10px'}}>
                                            <Sample setChild={this.setValue.bind(this)} reqFlag={true} name={'associationid'} label={'Association Id'} value={this.state.aid} disable={false} style={customStyle.textFieldWrp} length={5}  fieldType={'treatment'} errMsg={'Enter Association Id'} helperMsg={'Association Id Required'}  parentDetails={{name:'associationid'}}></Sample>
                                        </div>
                                        <div style={{width:'224px', margin:'10px'}}>
                                            <Sample setChild={this.setValue.bind(this)} reqFlag={true} name={'clientid'} label={'Client Id'} value={this.state.cid} disable={false} style={customStyle.textFieldWrp} length={5}  fieldType={'treatment'} errMsg={'Enter Client Id'} helperMsg={'Client Id Required'}  parentDetails={{name:'clientid'}}></Sample>
                                        </div>
                                    </div>
                                    <div style={customStyle.urlWrp}>
                                        <Sample setChild={this.setValue.bind(this)} reqFlag={true} name={'baseUrl'} label={'Enter your base url here'} value={this.state.baseUrl} disable={true} style={customStyle.textFieldWrpurl} length={5}  fieldType={'treatment'} errMsg={'Enter base url'} helperMsg={'Base url Required'}  parentDetails={{name:'burl'}}></Sample>
                                    </div>
                                    <div style={customStyle.urlWrp}>
                                        <div style={customStyle.HomeLoginUrlWrp}>{this.state.url}</div>
                                    </div>
                                    <div style={customStyle.urngenBtnwrp}>
                                        <div>
                                            <GenBtn1 variant="contained"  color="primary" onClick={()=>this.generateUrl('login')}  disabled={this.state.genrate}>Generate URL</GenBtn1>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </Modal.Body>
                        <Modal.Footer>
                            <NextButton style={{margin: '0', marginRight : '10px', width: '96px', height: '40px'}} onClick={this.sendMail()}>Send Mail</NextButton>
                            <CustomButton style={{height : '40px'}} onClick={() => this.setState({mailModal:false, loaderShow : false})}>Cancel</CustomButton>
                        </Modal.Footer>
                    </Modal>

                    {/*=================================== Message Model ======================================*/}
                    {this.state.sendQuoteFlag ? (
                        <Modal size="lg" show={this.state.msgModal} onHide={(event) => this.setState({msgModal:false,loaderShow : false})} centered backdrop='static'>
                            <Modal.Header style={styles.modal_header} closeButton>
                                <Modal.Title>Message</Modal.Title>
                            </Modal.Header>

                            <Modal.Body style={customStyle.tableSendquoteErrorList}>
                                {
                                    this.state.loaderShow ? <Loader></Loader> : ''
                                }

                                <div style={customStyle.HomeContainer}>
                                    <h6>{this.state.errMsg}</h6>
                                    <table class="table table-bordered">
                                            <thead>
                                                <tr>
                                                <th style={{background:'#F2F2F2'}}>Record</th>
                                                <th style={{background:'#F2F2F2'}}>Name</th>
                                                <th style={{background:'#F2F2F2'}}>Missing fields</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    this.state.sendQuoteError.map((data)=>{
                                                    return  <tr>
                                                                <td>{data.record}</td>
                                                                <td>{data.firstName}  {data.lastName}</td>
                                                                <td>{data.missingFields.map((val)=>{
                                                                    return <span style={{textTransform:'capitalize'}}>{val} <span> , </span></span>
                                                                })}</td>
                                                            </tr>
                                                    })
                                                }
                                            </tbody>
                                        </table>
                                </div>

                            </Modal.Body>
                            <Modal.Footer>
                                <NextButton style={{height : '40px'}} onClick={this.handleOK}>Ok</NextButton>
                            </Modal.Footer>
                        </Modal>
                    ) : (
                        <MessageToast show={this.state.msgModal} type={this.state.msgType} message={this.state.errMsg} onClose={this.handleOK} />
                    )}
                    {/*=================================== Message Model ======================================*/}

                   {/*------------ update employer modal namita ------------------------------*/}

                    <Modal size="lg" show={this.state.viewEmployerModal} onHide={(event) => this.setState({viewEmployerModal:false,loaderShow : false, employerDetailsObj : []})}  centered backdrop='static'>
                        <Modal.Header style={styles.modal_header} closeButton>
                            <Modal.Title>Edit Employer</Modal.Title>
                        </Modal.Header>
                        <Modal.Body  style={{ padding: '15px',height : '330px', overflow : 'auto' }}>
                            {
                                this.state.loaderShow ? <Loader></Loader> : ''
                            }
                            
                             <div style={{ flexGrow: 1 }}>
                            <Grid container spacing={2} justify="center" >
                                <Grid item xs={12} sm={10}>
                                    <Sample setChild={this.setEmpValue.bind(this)} reqFlag={true} name={'CompanyName'} label={'Company Name'} value={this.state.compName} disable={false} style={customStyle.textFieldWrpAgent} length={50} fieldType={'street'} errMsg={'Enter valid company name'} helperMsg={'Company name required'} parentDetails={{ name: 'compName' }}></Sample>
                                </Grid>
                                <Grid item xs={12} sm={10}>
                                    <span>Address Details</span>
                                </Grid>
                                <Grid item xs={12} sm={5}>
                                    <Sample setChild={this.setEmpValue.bind(this)} reqFlag={true} name={'zipCode'} label={'Zip Code'} value={this.state.zipCode} disable={false} style={customStyle.textFieldWrpAgent} length={6} fieldType={'zip'} errMsg={'Enter valid zip code'} helperMsg={'Zip code required'} parentDetails={{ name: 'zipCode' }}></Sample>
                                </Grid>
                                <Grid item xs={12} sm={5}>
                                    <Sample setChild={this.setEmpValue.bind(this)} reqFlag={true} name={'city'} label={'City'} value={this.state.city} disable={true} style={customStyle.textFieldWrpAgent} length={5} fieldType={'city'} errMsg={'Enter valid city'} helperMsg={'City required'} parentDetails={{ name: 'city' }}></Sample>
                                </Grid>
                                <Grid item xs={12} sm={5}>
                                    <Sample setChild={this.setEmpValue.bind(this)} reqFlag={true} name={'state'} label={'State'} value={this.state.state} disable={true} style={customStyle.textFieldWrpAgent} length={25} fieldType={'city'} errMsg={'Enter valid state'} helperMsg={'State required'} parentDetails={{ name: 'state' }}></Sample>
                                </Grid>
                                <Grid item xs={12} sm={5}>
                                    <Sample setChild={this.setEmpValue.bind(this)} reqFlag={false} name={'street'} label={'Street, Suite'} value={this.state.street} disable={false} style={customStyle.textFieldWrpAgent} length={25} fieldType={'street'} errMsg={'Enter valid street'}  parentDetails={{ name: 'street' }}></Sample>
                                </Grid>
                                <Grid item xs={12} sm={10}>
                                    <span>SIC</span>
                                </Grid>
                                <Grid item xs={12} sm={5} style={{ width: '90%' }}>
                                    <CommonDropDwn setChild={this.setEmpDropDownValue.bind(this)} reqFlag={false} name={'division'} label={'Division'} value={this.state.division} fieldType={'dropDwn'} disable={false} style={customStyle.dropDown} List={this.state.divisionList} errMsg={'Select valid division'}  parentDetails={{ name: 'division' }}></CommonDropDwn>
                                </Grid>
                                <Grid item xs={12} sm={5}>
                                    <CommonDropDwn setChild={this.setEmpDropDownValue.bind(this)} reqFlag={false} name={'industry'} label={'Industry'} value={this.state.industry} disable={this.state.industryList.length === 0} style={customStyle.textFieldWrpAgent} List={this.state.industryList} errMsg={'Select valid industry'}  parentDetails={{ name: 'industry' }}></CommonDropDwn>
                                </Grid>
                                <Grid item xs={12} sm={5}>
                                    <CommonDropDwn setChild={this.setEmpDropDownValue.bind(this)} reqFlag={false} name={'codeTitle'} label={'SIC Code Title'} value={this.state.codeTitle} disable={this.state.codeTitleList.length === 0} style={customStyle.textFieldWrpAgent} List={this.state.codeTitleList} errMsg={'Select valid code title'}  parentDetails={{ name: 'codeTitle' }}></CommonDropDwn>
                                </Grid>
                                <Grid item xs={12} sm={5}>
                                    <Sample setChild={this.setEmpValue.bind(this)} reqFlag={false} name={'sicCode'} label={'SIC Code'} value={this.state.code} disable={true} style={customStyle.textFieldWrpAgent} length={10} fieldType={'num'} errMsg={'Enter valid code'}  parentDetails={{ name: 'code' }}></Sample>
                                </Grid>
                                <Grid item xs={12} sm={10}>
                                    <span>Employer Contact Details</span>
                                </Grid>
                                <Grid item xs={12} sm={5}>
                                    <SampleName setChild={this.setEmpValue.bind(this)} reqFlag={true} name={'fistName'} label={'First Name'} value={this.state.firstName} disable={false} style={customStyle.textFieldWrpAgent} length={25} fieldType={'fullName'} errMsg={'Enter valid first name'} helperMsg={'First name required'} parentDetails={{ name: 'firstName' }}></SampleName>
                                </Grid>
                                <Grid item xs={12} sm={5}>
                                    <SampleName setChild={this.setEmpValue.bind(this)} reqFlag={true} name={'lastName'} label={'Last Name'} value={this.state.lastName} disable={false} style={customStyle.textFieldWrpAgent} length={25} fieldType={'fullName'} errMsg={'Enter valid last name'} helperMsg={'Last name required'} parentDetails={{ name: 'lastName' }}></SampleName>
                                </Grid>
                                <Grid item xs={12} sm={5}>
                                    <Sample setChild={this.setEmpValue.bind(this)} reqFlag={false} name={'jobTitle'} label={'Job title'} value={this.state.jobTitle} disable={false} style={customStyle.textFieldWrpAgent} length={50} fieldType={'text'} errMsg={'Enter valid job title'}  parentDetails={{ name: 'jobTitle' }}></Sample>
                                </Grid>
                                <Grid item xs={12} sm={5}>
                                    <Sample setChild={this.setEmpValue.bind(this)} reqFlag={true} name={'workEmail'} label={'Work Email'} value={this.state.workEmail} style={customStyle.textFieldWrpAgent} length={50} fieldType={'email'} errMsg={'Enter valid work email'} helperMsg={'Work email required'} parentDetails={{ name: 'workEmail' }}></Sample>
                                </Grid>
                                <Grid item xs={12} sm={5}>
                                    <div>
                                        <MuiPhoneNumber
                                            name={"phone"}
                                            id="filled-required"
                                            label={"Mobile No."}
                                            data-cy="user-phone"
                                            variant="filled"
                                            defaultCountry={"us"}
                                            onlyCountries={["us"]}
                                            autoComplete='off'
                                            value={this.state.phone}
                                            length={17}
                                            onChange={(e) => this.setEmpValue(e, true, { name: 'phone' })}
                                            disable={false} style={customStyle.textFieldWrpAgent} fieldType={'phone'}
                                            errMsg={'Enter valid mobile no.'} helperMsg={'Mobile no. required'}
                                        />
                                        {(!this.state.phone || this.state.phone.length === 17) ? null : <p class="MuiFormHelperText-root MuiFormHelperText-contained Mui-required mobileErr">Enter valid mobile no.</p>}
                                        {/* <Sample setChild={this.setUserValue.bind(this)} reqFlag={true} name={'phone'} label={'Mobile No.'} value={this.state.phone} disable={false} style={customStyle.textFieldWrpAgent} length={10} fieldType={'phone'} errMsg={'Enter valid mobile no.'} helperMsg={'Mobile no. required'} parentDetails={{ name: 'phone' }}></Sample> */}
                                    </div>
                                </Grid>
                                <Grid item xs={12} sm={5}>
                                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                        <KeyboardDatePicker
                                            required
                                            onBlur={() => this.setState({ birthDtFocus: true })}
                                            onMouseOver={() => this.setState({ birthDt: true })}
                                            onMouseLeave={() => this.setState({ birthDt: false })}
                                            autoComplete='off'
                                            margin="none"
                                            id="date-picker-dialog"
                                            label="Select Program Effective Date"
                                            format="MM/dd/yyyy"
                                            error={this.state.dateErr} //&&!this.state.todayDateValid
                                            helperText={this.state.dateErr ? 'Enter valid date' : ''} //this.state.todayDateValid?'Date Required':
                                            value={myDate} //this.state.todayDateValid?null:
                                            onFocus={e => e.target.blur()}
                                            onCopy={this.handlerCopy}
                                            onPaste={this.handlerCopy}
                                            inputProps={{ style: { fontSize: '18px', fontFamily: 'Roboto, Arial, Helvetica, sans-serif', paddingLeft: '11px', paddingRight: '10px', marginTop: '11px', '&:focus': { outline: 'none' }, color: !this.state.birthDt ? 'grey' : '#1a2c40' } }}
                                            InputLabelProps={{ style: { paddingLeft: 10, paddingRight: 10, paddingTop: 12, color: !this.state.birthDtFocus ? 'grey' : this.state.birthDt ? '#1a2c40' : 'grey' } }}//|| !this.state.todayDateValid
                                            onChange={this.handleDateChange.bind(this)}
                                            variant="filled"
                                            // onMouseEnter={this.handleHover}
                                            TextFieldComponent={CssTextField}
                                            KeyboardButtonProps={{
                                                'aria-label': 'change date',
                                            }}
                                            style={{ width: '100%' }}
                                            shouldDisableDate={(e) => this.disableWeekends(e, this.state.USER_DATA.clientId)}
                                            minDate={new Date(tomorrow)}
                                            maxDate={new Date(futureDate)}
                                        />
                                        <span id='bd' style={customStyle.EnrollNew2Span}></span>

                                    </MuiPickersUtilsProvider>
                                </Grid>
                                <Grid item xs={12} sm={10}>
                                    <span style={{marginRight:'20px'}}>Health Administrator Contact Details</span>
                                    <Checkbox
                                        checked={this.state.copyEmpCheck}
                                        inputProps={{
                                            'aria-label': 'secondary checkbox',
                                        }}
                                        style={{ color: '#1a2c40' }}
                                        onClick={this.copyEmployerDetails}
                                    />
                                    <span>Same as above</span>
                                </Grid>
                                <Grid item xs={12} sm={5}>
                                    <SampleName setChild={this.setEmpValue.bind(this)} reqFlag={true} name={'adminFistName'} label={'First Name'} value={this.state.adminFirstName} disable={false} style={customStyle.textFieldWrpAgent} length={25} fieldType={'text'} errMsg={'Enter valid first name'} helperMsg={'First name required'} parentDetails={{ name: 'adminFirstName' }}></SampleName>
                                </Grid>
                                <Grid item xs={12} sm={5}>
                                    <SampleName setChild={this.setEmpValue.bind(this)} reqFlag={true} name={'adminLastName'} label={'Last Name'} value={this.state.adminLastName} disable={false} style={customStyle.textFieldWrpAgent} length={25} fieldType={'text'} errMsg={'Enter valid last name'} helperMsg={'Last name required'} parentDetails={{ name: 'adminLastName' }}></SampleName>
                                </Grid>
                                <Grid item xs={12} sm={5}>
                                    <Sample setChild={this.setEmpValue.bind(this)} reqFlag={true} name={'eeail'} label={'Email'} value={this.state.adminEmail} style={customStyle.textFieldWrpAgent} length={50} fieldType={'email'} errMsg={'Enter valid email'} helperMsg={'Email required'} parentDetails={{ name: 'adminEmail' }}></Sample>
                                </Grid>
                                <Grid item xs={12} sm={5}>
                                    <div>
                                        <MuiPhoneNumber
                                            name={"phoneNumber"}
                                            id="filled-required"
                                            label={"Mobile No."}
                                            data-cy="user-phone"
                                            variant="filled"
                                            defaultCountry={"us"}
                                            onlyCountries={["us"]}
                                            autoComplete='off'
                                            value={this.state.adminPhone}
                                            length={17}
                                            onChange={(e) => this.setEmpValue(e, true, { name: 'adminPhone' })}
                                            disable={false} style={customStyle.textFieldWrpAgent} fieldType={'adminPhone'}
                                            errMsg={'Enter valid mobile no.'} helperMsg={'Mobile no. required'}
                                        />
                                        {(!this.state.adminPhone || this.state.adminPhone.length === 17) ? null : <p class="MuiFormHelperText-root MuiFormHelperText-contained Mui-required mobileErr">Enter valid mobile no.</p>}
                                    </div>
                                </Grid>

                                <Grid item xs={12} sm={10} style={{marginTop: 15, marginBottom: -15}}>
                                        <span style={customStyle.textBold}>Payroll Cycle</span>
                                    </Grid>
                                    <Grid item xs={12} sm={10}>
                                        <div>
                                            <FormControl component="fieldset">
                                                <RadioGroup
                                                    row
                                                    aria-label="days"
                                                    name="row-radio-buttons-group"
                                                    value={this.state.payrollCycle}
                                                    onChange={(event) => this.setState({ payrollCycle: event.target.value })}
                                                >
                                                    <FormControlLabel
                                                        value="Weekly"
                                                        control={<PurpleRadio />}
                                                        label="Weekly"
                                                    />
                                                    <FormControlLabel
                                                        value="BiWeekly"
                                                        control={<PurpleRadio />}
                                                        label="Every Two Weeks"
                                                    />
                                                    <FormControlLabel
                                                        value="Monthly"
                                                        control={<PurpleRadio />}
                                                        label="Monthly"
                                                    />
                                                </RadioGroup>
                                            </FormControl>
                                        </div>
                                    </Grid>
                                    <Grid item xs={12} sm={10} style={customStyle.sectionPart}>
                                        <span style={customStyle.textBold}>Employer Contribution</span>
                                    </Grid>
                                    <Grid item xs={12} sm={10} style={{marginTop: -15, marginBottom: -15}}>
                                        <div>
                                            <FormControl component="fieldset">
                                                <RadioGroup
                                                    row
                                                    aria-label="days"
                                                    name="row-radio-buttons-group"
                                                    value={this.state.contributionType}
                                                    onChange={(event) => this.setState({ contributionType: event.target.value, employerContribution: '' })}
                                                >
                                                    <FormControlLabel
                                                        value="Doller"
                                                        control={<PurpleRadio />}
                                                        label="Fixed Amount"
                                                    />
                                                    <FormControlLabel
                                                        value="Percentage"
                                                        control={<PurpleRadio />}
                                                        label="Percentage of Monthly Contribution"
                                                    />
                                                </RadioGroup>
                                            </FormControl>
                                        </div>
                                    </Grid>
                                    <Grid item xs={12} sm={10}>
                                        <Grid item xs={12} sm={6}>
                                        <Sample setChild={this.setEmpValue.bind(this)} reqFlag={false} name={'employerContribution'} label={this.state.contributionType === 'Doller' ? 'Employer Contribution ($)' : 'Employer Contribution (%)'} value={this.state.employerContribution} disable={false} style={customStyle.textFieldWrpAgent} length={this.state.contributionType == 'Doller' ? 10 : 6} fieldType={`employerContribution${this.state.contributionType}`} errMsg={this.state.contributionType == 'Doller' ? 'Enter valid amount' : 'Enter valid percentage between 0 to 100'} helperMsg={'Employer Contribution required'} parentDetails={{ name: 'employerContribution' }}></Sample>
                                            {/* <Sample setChild={this.setEmpValue.bind(this)} name={'employerContribution'} label={`${!this.state.employerContribution ? this.state.contributionType == 'Doller' ? '$0' : '0%' : ''}`} value={this.state.employerContribution == '' ? '' : this.state.contributionType == 'Doller' ? '$'+`${this.state.employerContribution}` : `${this.state.employerContribution}%`} disable={false} style={customStyle.textFieldWrpAgent} length={60} fieldType={'employerContribution'} errMsg={'Enter valid amount'} helperMsg={'Employer Contribution required'} parentDetails={{ name: 'employerContribution' }}></Sample> */}
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12} sm={10} style={customStyle.sectionPart}>
                                        <span style={customStyle.textBold}>Setup ACH</span>
                                    </Grid>
                                    <Grid item xs={12} sm={5}>
                                        <Sample setChild={this.setEmpValue.bind(this)} reqFlag={false} name={'Bank_Name'} label={'Bank Name'} value={this.state.bankName} disable={false} style={customStyle.textFieldWrpAgent} length={60} fieldType={'bank_name'} errMsg={'Enter valid bank name'} parentDetails={{ name: 'bankName' }}></Sample>
                                    </Grid>
                                    <Grid item xs={12} sm={5}>
                                        <Sample setChild={this.setEmpValue.bind(this)} reqFlag={false} name={'Account_Name'} label={'Name on Account'} value={this.state.accountName} disable={false} style={customStyle.textFieldWrpAgent} length={120} fieldType={'accountName'} errMsg={'Enter valid account name'} parentDetails={{ name: 'accountName' }}></Sample>
                                    </Grid>
                                    <Grid item xs={12} sm={5}>
                                        <Sample setChild={this.setEmpValue.bind(this)} reqFlag={false} name={'Routing_Number'} label={'Routing Number'} value={this.state.routingNo} disable={false} style={customStyle.textFieldWrpAgent} length={9} fieldType={'routingNo'} errMsg={'Enter valid routing number'} parentDetails={{ name: 'routingNo' }}></Sample>
                                    </Grid>
                                    <Grid item xs={12} sm={5}>
                                        <Sample setChild={this.setEmpValue.bind(this)} reqFlag={false} name={'Account_Number'} label={'Account Number'} value={this.state.accountNumber} disable={false} style={customStyle.textFieldWrpAgent} length={26} fieldType={'accountNumber'} errMsg={'Account number must be 4 and up to 26 digits'} parentDetails={{ name: 'accountNumber' }}></Sample>
                                    </Grid>
                                    <Grid item xs={12} sm={10}>
                                        <Grid item xs={12} sm={6}>
                                            <CommonDropDwn setChild={this.setEmpValue.bind(this)} name={"Account_Type"} account={true} label={"Account Type"} value={this.state.accountType} disable={false} style={customStyle.dropDown} fieldType={"dropDwn"} List={this.state.accountTypes} parentDetails={{ name: "accountType" }}></CommonDropDwn>
                                        </Grid>
                                    </Grid>
                            </Grid>

                        </div>



                        </Modal.Body>
                        <Modal.Footer>
                        <NextButton style={{ margin: '0', marginRight: '10px', width: '95px', height: '40px' }} disabled={this.state.disableSubmit} onClick={() => this.addEmployer()}>UPDATE</NextButton>
                        <CustomButton style={{ height: '40px' }} onClick={() => this.closeEmployerModal()}>Cancel</CustomButton>
                        </Modal.Footer>
                    </Modal>


                 {/*------------ update employer modal end------------------------------*/}

                    <Modal size="xs" show={this.state.confirmationModal} backdrop="static" centered>
                        <Modal.Header style={customStyle.modal_header}>
                            <Modal.Title>Send Quote</Modal.Title>
                        </Modal.Header>
                        <Modal.Body style={{ margin: '10px',textAlign:'left',fontFamily : 'Roboto, Arial, Helvetica, sans-serif' }}>

                            {
                                this.state.programsList && this.state.programsList[1] ?
                                <CommonDropDwnProg setChild={this.setEmailId.bind(this)} name={'Prgrams'} label={"Please select a program type"} style={{width:'100%',color:"#fff"}} fieldType={'dropDwn'} List={this.state.programsList} isProgram={true} value={this.state.program}  parentDetails={{flag:'program', name:'program', label:'program'}} helperMsg={'Program required'} />
                                : 
                                `Send a Quote for ${this.state.programName} Programs`
                            }
                            {
                                this.state.planList && this.state.planList[0] &&
                                <FormControl fullWidth style={{ marginTop: 13 }}>
                                    <InputLabel id="demo-multiple-checkbox-label" style={{ paddingLeft: 15, marginTop: -4 }}>Please select a plan type</InputLabel>
                                    <Select
                                        labelId="demo-multiple-checkbox-label"
                                        id="demo-multiple-checkbox"
                                        multiple
                                        value={this.state.planNames}
                                        onChange={this.handlePlanNamesChange}
                                        input={<OutlinedInput label="Please select a Plan type" />}
                                        renderValue={(selected) => selected.join(', ')}
                                        style={{ width: 446 }}
                                    //   MenuProps={MenuProps}
                                    >
                                        {this.state.planList.map((item) => (
                                            <MenuItem key={item} value={item}>
                                                <Checkbox checked={this.state.planNames.includes(item)} />
                                                <text>{item}</text>
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            }
                            <div style={{marginBottom: 20}}></div>
                            {
                                this.state.countData && this.state.countData.total ?
                                <CommonDropDwn setChild={this.setEmailId.bind(this)} reqFlag={true} name={'Email'} label={"Please select recipient's email address"} value={this.state.selectedEmail} fieldType={'dropDwn'} disable={false} style={customStyle.dropDown}  List={this.state.emp_email_id} errMsg={'Select valid email'} helperMsg={'Email required'}  parentDetails={{name:'selectedEmail'}}></CommonDropDwn>

                               
                                :
                                <h6>No census data available!</h6>
                            }
                        </Modal.Body>
                        <Modal.Footer style={{alignItems:'right'}}>
                            {
                                this.state.countData && this.state.countData.total ?
                            <NextButton style={{width: '90px', height: '40px'}} disabled={this.state.selectedEmail === '' || (this.state.planList[0] && this.state.planNames[0] == null)} onClick={()=>this.sendEmpQuoteMail()}>Confirm</NextButton>
                                :
                                null
                            }
                            <CustomButton style={{marginLeft: '10px', width: '70px', height: '40px'}} onClick={()=>{this.setState({ confirmationModal : false,loaderShow : false, selectedEmail : '', planNames: []})}}>Cancel</CustomButton>
                        </Modal.Footer>
                    </Modal>
                </div>
                <div style={{fontSize:'11px', marginTop:'15px', fontFamily: "Roboto, Arial, Helvetica, sans-serif"}}>
                    <Footer/>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state =>{
    return {
        agentId: state.agentId,
        clientId: state.clientId,
        associationId: state.associationId,
        clientName : state.clientName
    }
}

export default connect(mapStateToProps) (Prospect);